import { PlusCircleOutlined } from "@ant-design/icons";
import { Card, Col, Tooltip } from "antd";
import React from "react";
import "./listform.css";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../../../experience/utils/UrlUtils";
import { useGetRole } from "../../../../experience/generic/hooks/useGetRole";

const { Meta } = Card;

const CreateFormCard = (baseLinkToNavigate) => {
  const navigate = useNavigate();
  const role = useGetRole();

  return (
    <Col xs={24} md={12} xl={8}>
      <Card
        className="form-item-style"
        style={{ display: 'flex', flexDirection: 'column' }}
        actions={[
          <Tooltip placement="bottom" title="Create">
            <PlusCircleOutlined
              onClick={() => {
                navigate(RoleToLinkMapper(role) + "create-form");
              }}
            />
          </Tooltip>,
        ]}
      >
        <Meta title="Create New Form" description="You can create a form of yours" className="create-form-card"/>
      </Card>
    </Col>
  );
};

export default CreateFormCard;
